import { useTranslation } from 'react-i18next';
import { PasswordIcon, ProtectionIcon } from '../../pages/icons';
import * as S from './styled';

interface ContinueButtonProps {
  onClick: () => void;
  customText?: string;
  disabled?: boolean;
  customId?: string;
  mt?: string | number;
  bottomMargin?: string | number;
  inverted?: boolean;
  stickyProps?: {};
  customStyles?: {};
  withSecureLabels?: boolean;
}

export const ContinueButton = ({
  onClick,
  customText,
  disabled,
  customId,
  mt,
  bottomMargin,
  inverted = false,
  stickyProps,
  customStyles,
  withSecureLabels = false,
}: ContinueButtonProps) => {
  const { t } = useTranslation();
  const customInner = customText || 'continue';
  const onClickFunc = () => {
    if (disabled) return;
    onClick();
  };
  return (
    <>
      {withSecureLabels ? (
        <S.ButtonWrapper {...stickyProps}>
          <S.StyledButton
            onClick={onClickFunc}
            disabled={disabled}
            id={customId || 'continue-button'}
            $mt={mt}
            $bottomMargin={bottomMargin}
            $inverted={inverted}
            $customStyles={customStyles}
            $withSecureLabels={withSecureLabels}
          >
            {t(customInner)}
          </S.StyledButton>
          <S.TrustLabels>
            <S.TrustItem>
              <ProtectionIcon />
              <S.TrustText>{t('confidential')}</S.TrustText>
            </S.TrustItem>
            <S.TrustItem>
              <PasswordIcon />
              <S.TrustText>{t('secure_ssl')}</S.TrustText>
            </S.TrustItem>
          </S.TrustLabels>
        </S.ButtonWrapper>
      ) : (
        <S.StyledButton
          onClick={onClickFunc}
          disabled={disabled}
          id={customId || 'continue-button'}
          $mt={mt}
          $bottomMargin={bottomMargin}
          $inverted={inverted}
          $customStyles={customStyles}
          {...stickyProps}
        >
          {t(customInner)}
        </S.StyledButton>
      )}
    </>
  );
};
